import KeenSlider from 'keen-slider';

function init(el) {
  const slider = el.querySelector('.slider');
  if (!slider) return;

  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove('active');
        });
      }
      function addActive(idx) {
        slider.slides[idx].classList.add('active');
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener('click', () => {
            main.moveToIdx(idx);
          });
        });
      }

      slider.on('created', () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on('animationStarted', (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(next);
        });
      });
    };
  }
  new KeenSlider(
    '.thumbnail',
    {
      initial: 0,
      slides: {
        perView: 4,
        spacing: 16,
      },
    },
    [ThumbnailPlugin(new KeenSlider(slider))]
  );
}

export default function () {
  document.querySelectorAll('section[data-block="slider"]').forEach(init);
}
